<template>
    <el-button :type="type" v-bind="$attrs" v-on="$listeners" icon="fa fa-fw fa-search">
        查询
    </el-button>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: 'primary'
        }
    },
    methods: {
    }
}
</script>
